// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Xo-LP","bump":"Button_bump__x24kc"};